import { AppError } from '../../contracts/errors.js'

export function normalizeProvider(provider = {}) {
  return {
    id: String(provider.id || 'default'),
    name: String(provider.name || provider.id || '默认服务'),
    baseUrl: String(provider.baseUrl || '').replace(/\/+$/, ''),
    generationPath: provider.generationPath || '/images/generations',
    editPath: provider.editPath || '/images/edits',
    apiKey: String(provider.apiKey || ''),
  }
}

export function buildImageRequest(job, provider) {
  const config = normalizeProvider(provider)
  if (!config.baseUrl) throw new AppError('provider.base-url-missing', '未配置服务地址', { category: 'configuration' })
  const edit = job.parameters?.mode === 'edit'
  const images = Array.isArray(job.refs) ? job.refs : []
  const body = { model: job.parameters?.model || undefined, prompt: job.prompt ?? job.text ?? '', n: Number(job.parameters?.count || 1) }
  if (images.length === 1) body.image = images[0]
  if (images.length > 1) body.image = images
  return { url: `${config.baseUrl}${edit ? config.editPath : config.generationPath}`, headers: { 'Content-Type': 'application/json', ...(config.apiKey ? { Authorization: `Bearer ${config.apiKey}` } : {}) }, body }
}
